import ArchivePostTypes from './archive-post-types'
import Cards from './cards'
import ColorHero from './color-hero'
import ColorsGrid from './colors-grid'
import DoubleParagraph from './double-paragraph'
import Form from './form'
import FullBanner from './full-banner'
import FullHero from './full-hero'
import Heading from './heading'
import Hero from './hero'
import HomeHero from './home-hero'
import ImageGallery from './image-gallery'
import Newsletter from './newsletter'
import Newsroom from './newsroom'
import NewsroomGrid from './newsroom-grid'
import Paragraph from './paragraph'
import ProductHero from './product-hero'
import ProductsGrid from './products-grid'
import PushBanner from './push-banner'
import Quote from './quote'
import RetailsGrid from './retails-grid'
import Showcase from './showcase'
import SingleMedia from './single-media'
import Spacer from './spacer'
import TermsGrid from './terms-grid'
import Timeline from './timeline'
import VideoPlayer from './video-player'
import Wishlist from './wishlist'

export const sectionsMap: any = {
  archive_post_types: ArchivePostTypes,
  cards: Cards,
  'color-hero': ColorHero,
  'colors-grid': ColorsGrid,
  'double-paragraph': DoubleParagraph,
  form: Form,
  'full-banner': FullBanner,
  'full-hero': FullHero,
  heading: Heading,
  hero: Hero,
  'home-hero': HomeHero,
  'image-gallery': ImageGallery,
  newsletter: Newsletter,
  newsroom: Newsroom,
  'newsroom-grid': NewsroomGrid,
  paragraph: Paragraph,
  'product-hero': ProductHero,
  'products-grid': ProductsGrid,
  'push-banner': PushBanner,
  quote: Quote,
  'retails-grid': RetailsGrid,
  showcase: Showcase,
  'single-media': SingleMedia,
  spacer: Spacer,
  'terms-grid': TermsGrid,
  timeline: Timeline,
  'video-player': VideoPlayer,
  wishlist: Wishlist
}
